"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainWrapper = void 0;
var styles_1 = require("@material-ui/core/styles");
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
var useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var useStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return createStyles_1.default({
        root: {
            display: 'flex',
        },
        mainContent: (_a = {
                position: 'relative',
                top: 68,
                flexGrow: 1,
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                })
            },
            _a[theme.breakpoints.up('sm')] = {
                top: 64,
                maxWidth: '1200px',
                // minWidth: '800px',
                margin: '0 auto',
                width: '80vw',
                padding: '24px',
            },
            _a),
    });
});
exports.MainWrapper = function (props) {
    var children = props.children;
    var classes = useStyles();
    var theme = styles_1.useTheme();
    var isDesktop = useMediaQuery_1.default(theme.breakpoints.up('sm'), {
        defaultMatches: true,
    });
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("main", { className: clsx_1.default(classes.mainContent) }, children)));
};
//# sourceMappingURL=MainWrapper.js.map